<template>
  <div v-if="items" class="gp-content">
    <table-tile-bar :view.sync="view" :refresh="reset">
      <p class="level-item is-size-4 bar-title">Assets</p>
      <pagination
        class="level-item"
        :next="hasNext"
        :prev="hasPrev"
        :nextClick="nextPage"
        :prevClick="prevPage"
        :page="page"
        :perPage="pageSize"
        :itemCount="itemCount"
        :total="total"
        :loading="loading">
      </pagination>
      <assets-filter-bar
        ref="filterBar"
        :filter.sync="filter"
        class="level-item">
      </assets-filter-bar>
      <div class="tags level-item">
        <span
          v-for="filter in filterList"
          :key="filter"
          class="tag is-rounded">
          <span>{{ filter }}</span>
          <a @click="removeFilter(filter)" role="button" tabindex="0" class="delete is-small"></a>
        </span>
      </div>
    </table-tile-bar>
    <div class="scroll-vertical full-height">
      <assets-table v-if="view === 'table'"
        :assets="items"
        :sortDirection="sortDirection"
        :sortField="sortField"
        :onSort="onSort"
        v-on:asset-table-tag-click="$refs.filterBar.addTagFilter($event.tag)"
        v-on:asset-table-version-click="$refs.filterBar.addVersionFilter($event.version)">
      </assets-table>
      <assets-tiles v-else :assets="items"></assets-tiles>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination';
import TableTileBar from '@/components/TableTileBar.vue';
import AssetsTable from '@/components/assets/AssetsTable.vue';
import AssetsTiles from '@/components/assets/AssetsTiles.vue';
import Pagination from '@/components/Pagination.vue';
import AssetsFilterBar from '@/components/assets/AssetsFilterBar.vue';

export default {
  name: 'Assets',
  mixins: [pagination],
  components: {
    AssetsTable,
    AssetsTiles,
    TableTileBar,
    Pagination,
    AssetsFilterBar,
  },
  data() {
    return {
      endpoint: 'primary/listAssets',
      sortDirection: 'ASC',
      sortField: 'hostName',
      sortableFields: [
        'version',
        'label',
        'hostName',
        'checkin',
        'profile',
        'modelName',
        'macosVersion',
      ],
      showFilter: false,
      tagsFilterTags: [],
      filterType: 'tags',
      filterList: [],
      selectedLabel: '',
      filter: {
        filters: [],
        operator: 'or',
      },
    };
  },
  watch: {
    filter() {
      this.reset();
    },
  },
  computed: {
    view: {
      set(value) { this.$store.commit('assetViewState/SET_VIEW', value); },
      get() { return this.$store.state.assetViewState.view; },
    },
    requestVars() {
      return {
        direction: this.sortDirection,
        field: this.sortField,
        filter: this.filter,
      };
    },
    tagsFilter() {
      if (this.tagsFilterTags.length > 0) {
        return {
          any: this.tagsFilterTags,
          operator: 'or',
        };
      }
      return null;
    },
    // filter() {
    //   const filter = {
    //     filters: {},
    //   };
    //   this.filterList.forEach((f) => {
    //     const filterItem = f.split(':');
    //     if (filterItem[0] === 'tag') {
    //       if (Object.prototype.hasOwnProperty.call(filter.filters, 'tags')) {
    //         filter.filters.tags.any.push(filterItem[1]);
    //       } else {
    //         filter.filters.tags = {
    //           any: [filterItem[1]],
    //           operator: 'or',
    //         };
    //       }
    //     }
    //   });
    //   if (Object.keys(filter.filters).length > 0) {
    //     return filter;
    //   }
    //   return null;
    // },
  },
  async mounted() {
    this.refresh();
  },
  methods: {
    onSort(field, order) {
      this.sortDirection = order.toUpperCase();
      this.sortField = field;
      this.reset();
    },
    addTagFilter(tag) {
      this.tagsFilterTags.push(tag);
    },
    removeTagFilter(tag) {
      this.tagsFilterTags = this.tagsFilterTags.filter(t => t !== tag);
    },
    onTagClick(tag) {
      this.filterList.push(`tag:${tag}`);
    },
    removeFilter(filter) {
      this.filterList = this.filterList.filter(f => f !== filter);
    },
  },
};
</script>

<style lang="scss" scoped>

.level-item:not(:last-child) {
  margin-bottom: 0;
}

.full-height {
  height: 100%;
}
</style>
